var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVastraGotLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-ee2957cf-3ca3-4e0b-8a1d-a84af0011e52",
    "data-name": "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 91.6524,
    height: 78.6908,
    viewBox: "0 0 91.6524 78.6908",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .uuid-f5424025-e3da-4da1-8b7f-b9568273eef9 {\n        fill: #010101;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "uuid-f5424025-e3da-4da1-8b7f-b9568273eef9",
    d: "M48.3913,54.3469c-7.2189.7191-14.7788-1.6806-20.2264-5.9801l17.66,30.324c2.8757-4.938,15.0416-25.8282,17.6598-30.324-4.2319,3.3198-9.442,5.4769-15.0934,5.9801Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "uuid-f5424025-e3da-4da1-8b7f-b9568273eef9",
    d: "M91.6524,0h-26.9447c-3.9196.0769-9.3184-.217-13.2509.5206-8.1798,1.5048-17.0972,6.4954-20.1347,17.1585-.7997,2.9835-.9089,6.361-.0485,9.3721,2.2833,9.0217,12.1829,15.0418,20.6032,10.2961,3.7985-2.1743,6.1885-6.5452,5.8399-10.9252-.3032-6.0638-5.8623-11.0703-11.8969-10.9587,3.2429-2.7607,7.7629-4.0035,11.968-3.3198,0,0,0,.0001.0001.0001,9.4072,1.5144,15.7685,12.0946,14.2269,21.5741L91.6524,0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "uuid-f5424025-e3da-4da1-8b7f-b9568273eef9",
    d: "M39.8351,0H0l19.6355,33.7178c-.3055-1.7055-.4834-3.4673-.4786-5.2608C19.1949,14.4071,28.8405,4.1907,39.8351,0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVastraGotLogo);
export default __webpack_public_path__ + "static/media/vastraGot-logo.0307bc0e1508335a37ea1939eeb3428e.svg";
export { ForwardRef as ReactComponent };